<template>
    <div>
        <p>{{ data.description }}</p>
        <button type="button" class="p-button" @click="openVideoLink">{{ data.label }}</button>
    </div>
</template>

<script setup>
const props = defineProps({
    data:Object,
    field:Object,
})

function openVideoLink() {
    window.open(props.data['sags-digital-video-link'], 'bewerbung');
}
</script>